export const COUNTRIES = [
  {
    code: '229',
    countryCode: 'BJ',
    name: 'Bénin',
    flag: 'https://flagcdn.com/w40/bj.png',
    example: '01 97 00 00 00'
  },
  {
    code: '228',
    countryCode: 'TG',
    name: 'Togo',
    flag: 'https://flagcdn.com/w40/tg.png',
    example: '90 00 00 00'
  },
  {
    code: '225',
    countryCode: 'CI',
    name: "Côte d'Ivoire",
    flag: 'https://flagcdn.com/w40/ci.png',
    example: '07 00 00 00 00'
  },
  {
    code: '226',
    countryCode: 'BF',
    name: 'Burkina Faso',
    flag: 'https://flagcdn.com/w40/bf.png',
    example: '70 00 00 00'
  },
  {
    code: '223',
    countryCode: 'ML',
    name: 'Mali',
    flag: 'https://flagcdn.com/w40/ml.png',
    example: '70 00 00 00'
  },
  {
    code: '241',
    countryCode: 'GA',
    name: 'Gabon',
    flag: 'https://flagcdn.com/w40/ga.png',
    example: '06 00 00 00'
  },
  {
    code: '227',
    countryCode: 'NE',
    name: 'Niger',
    flag: 'https://flagcdn.com/w40/ne.png',
    example: '90 00 00 00'
  },
  {
    code: '221',
    countryCode: 'SN',
    name: 'Sénégal',
    flag: 'https://flagcdn.com/w40/sn.png',
    example: '77 000 00 00'
  },
  {
    code: '237',
    countryCode: 'CM',
    name: 'Cameroun',
    flag: 'https://flagcdn.com/w40/cm.png',
    example: '6 00 00 00 00'
  }
];

export const getCountryByCode = (code) => COUNTRIES.find(c => c.countryCode === code);
export const getPhoneExample = (countryCode) => getCountryByCode(countryCode)?.example || '00000000';
